import React from 'react'

const SkeletonTitle = ({ align }) => {
  return (
    <div className={`h-8 w-1/2 bg-gray-200 mb-4 rounded-md m-${align}`}>

    </div>
  )
}

export default SkeletonTitle